import useGoogleOneTap from 'hooks/Google/useGoogleOneTap.js';
import { appGoogleOneTapLogin } from 'models/auth';

const GoogleOneTap = ({ clientId, onCallPending, onCallbackSucceed, onCallbackFail }) => {
    const handleGoogleCallback = response => {
        onCallPending();
        appGoogleOneTapLogin(response.credential, { onCallbackFail, onCallbackSucceed });
    };

    useGoogleOneTap({
        clientId,
        callback: handleGoogleCallback,
    });

    return null;
};

export default GoogleOneTap;
